<template lang="pug">
    lairdnd-login(
        redirectTo="settings-profile-page",
        :settings="settings"
        :translations="translations"
    )
</template>

<script>
export default {
    name: 'login-page',

    metaInfo() { return {
        title: this.metaTitle,
        meta: [
            { name: 'description', content: this.metaDescription },
            { name: 'og:title', content: `${this.metaTitle} - Lair DND` },
            { name: 'og:description', content: this.metaDescription },
        ],
    }},

    data() { return {
        settings: {
            hideRegistration: false,
            hideForgotPassword: false,

            showSubmitErrorOnFields: true,

            register: {
                route: 'registration-page',
            },
            forgotPassword: {
                route: 'forgot-password-page',
            },

            form: {
                fields: {
                    username: {
                        attr: {
                            lazy: true,
                        },
                    },
                    password: {
                        attr: {
                            lazy: true,
                        },
                    },
                },
            },

            submitOnEnter: true,
        },

        translations: {
            title: 'Let’s get started',
            register: {
                label: 'Don’t have an account?',
                link: 'Register',
            },
            fields: {
                username: {
                    label: 'Email address',
                },
            },
            rememberMe: {
                label: 'Remember me',
            },
            forgotPassword: {
                label: 'Forgot your password?',
            },
            submitButtonTitle: 'Log in',
        },
    }},

    computed: {
        metaTitle() {
            return 'Log in'
        },
        metaDescription() {
            return 'Log in or sign up to your Lair DND'
        },
    },
}
</script>
